import React from 'react'
import Header from './Header'
import Footer from './Footer'

export default React.createClass({
  propTypes: {
    children: React.PropTypes.element
  },
  render() {
    return (
      <div className="content-wrapper">
        <Header/>
        <div className="content">
          {this.props.children}
        </div>
        <Footer/>
      </div>
    )
  }
})



// WEBPACK FOOTER //
// ./src/app/components/App.js